













































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import {
  getdatalist,
  resetPwd,
  adddata,
  updatauser,
  getuserinfo
} from '@/api/examineeManage'
import Pagination from '@/components/Pagination/index.vue'

@Component({
  name: 'guideManage',
  components: { Pagination }
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery)
    this.userid = window.sessionStorage.getItem('id')
  }
  private userid: any = '';
  private currtentpage = 1;
  private total: number = 0;
  private formObj = {
    dialogVisible: false
  };
  private sexoptions = [
    {
      label: '男',
      value: '0'
    },
    {
      label: '女',
      value: '1'
    }
  ];
  private roleoptions = [
    {
      label: '管理员',
      value: '0'
    },
    {
      label: '申报人',
      value: '1'
    }
  ];
  private stateoptions = [
    {
      label: '正常',
      value: '0'
    },
    {
      label: '待审核',
      value: '1'
    },
    {
      label: '禁用',
      value: '2'
    }
  ];
  private tableData = [];
  private userstate = '';
  private currentPage: number = 1;
  private diatitle = '';
  private usersex = ''; // 用户性别
  private userrole = ''; // 用户类型
  private isloading = true;
  private multipleSelection = [];
  private addParams: any = {
    username: '',
    loginname: '',
    phone: '',
    password: '',
    copesd: '',
    orgnanizeid: '',
    sex: 0,
    issue: 0,
    role: 1
  };
  private editparms: any = {
    // name: "",
    // description: "",
    // isuse: "",
    // id: "",
    // isdelete: "",
  };
  private listQuery = {
    isuse: 3,
    limit: 10,
    loginName: '',
    page: 1,
    role: 8,
    sex: 2
  };
  // 表单校验规则
  private rules = {
    username: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
    loginname: [{ required: true, message: '请输入登录名称', trigger: 'blur' }],
    orgnanizeid: [
      { required: true, message: '请输入所属机构名称', trigger: 'blur' }
    ],
    phone: [
      { required: true, message: '请输入联系方式', trigger: 'blur' },
      {
        required: true,
        pattern:
          /^((13|14|15|16|17|18)[0-9]{1}\d{8})|((166|199|198)[0-9]{1}\d{7})$/,
        message: '请输入正确的电话号码',
        trigger: 'blur'
      }
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    password: [
      { required: true, message: '请输入用户密码', trigger: 'blur' },
      { min: 8, message: '密码最少8位', trigger: 'blur' },
      {
        pattern: /[a-zA-Z][0-9]/,
        message: '请输入不少于8位(字母和数字组合)',
        trigger: 'blur'
      }
    ],
    copesd: [
      {
        required: true,
        validator: this.validatePass2,
        trigger: 'blur'
      }
    ]
  };
  handlePaste() {}
  // 获取列表
  private async confirmResetPassWord(row, index) {
    (this.$refs['popRef' + index] as any).doClose()
    await resetPwd(row.id).then((res) => {
      if (res.code === 200) {
        this.$message.success('重置成功')
        this.getList(this.listQuery)
      } else {
        this.$message.error(res.message)
      }
    })
      .catch(() => {})
  }

  private async getList(params: any) {
    await getdatalist(params)
      .then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.itemBeanList[0]
          this.total = res.data.total
          this.isloading = false
        }
      })
      .catch(() => {})
  }
  private validatePass2(rule, value, callback) {
    if (value == '') {
      callback(new Error('请再次输入密码'))
    } else if (value !== this.addParams.password) {
      callback(new Error('两次输入密码不一致!'))
    } else {
      callback()
    }
  }
  private handleSelectionChange(val) {
    this.multipleSelection = val
  }
  private removeuser() {
    this.getList(this.listQuery)
  }
  private changeuser(val) {
    console.log(val == '')
    if (val == '') {
      this.listQuery.sex = 2
    } else {
      this.listQuery.sex = Number(val)
    }
    this.getList(this.listQuery)
  }
  private changerole(val) {
    if (val == '') {
      this.listQuery.role = 2
    } else {
      this.listQuery.role = Number(val)
    }
    this.getList(this.listQuery)
  }
  private changestate(val) {
    if (val == '') {
      this.listQuery.isuse = 3
    } else {
      this.listQuery.isuse = Number(val)
    }
    this.getList(this.listQuery)
  }
  private async deletedata(params: any) {
    this.editparms.isdelete = 0
    this.editparms.id = params.id
    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async() => {
      await getdatalist(this.editparms).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList(this.listQuery)
          this.editparms = {
            name: '',
            description: '',
            isuse: -1,
            id: '',
            isdelete: 1
          }
        } else {
          this.$message({
            message: '删除失败',
            type: 'warning'
          })
        }
      })
    })
  }
  private onSubmit() {
    this.getList(this.listQuery)
  }
  private clearSearch() {
    this.listQuery = {
      isuse: 3,
      limit: 10,
      loginName: '',
      page: 1,
      role: 8,
      sex: 2
    }
    this.usersex = ''
    this.userrole = ''
    this.userstate = ''
    this.getList(this.listQuery)
  }
  private onCreatItem() {
    this.isuse = 1
    this.diatitle = '新建用户'
    this.editparms.id = ''
    this.addParams = {
      username: '',
      loginname: '',
      phone: '',
      password: '',
      copesd: '',
      orgnanizeid: '',
      sex: 0,
      issue: 0,
      role: 1
    }
    this.formObj.dialogVisible = true
    this.$nextTick(() => {
      (this.$refs.addParams as any).resetFields()
    })
  }
  private updatestate(row) {
    console.log(row)
    let title = ''
    let state = 0
    if (row.isuse == 0) {
      title = '禁用'
      state = 2
    } else if (row.isuse == 1) {
      title = '审核通过'
      state = 0
    } else {
      title = '启用'
      state = 0
    }
    this.$confirm('确定' + title + '所选人员吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        // 更改用户状态
        let param = {
          id: row.id,
          isdelete: 0,
          isuse: state,
          loginName: row.loginname,
          organname: row.organname,
          phone: row.phone,
          pwd: row.pwd,
          role: row.role,
          sex: row.sex,
          userName: row.username
        }
        console.log(param)
        updatauser(param).then((res) => {
          if (res.code === 200) {
            this.$message.success('状态更新成功')
            this.getList(this.listQuery)
          }
        })
      })
      .catch(() => {})
  }
  private async editItem(params: any) {
    const parm = { id: params.id }
    console.log(params)
    await getuserinfo(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false
        this.addParams = {
          username: res.data.username,
          loginname: res.data.loginname,
          phone: res.data.phone,
          password: res.data.pwd,
          copesd: res.data.pwd,
          orgnanizeid: res.data.organname,
          sex: res.data.sex,
          issue: res.data.issue,
          role: res.data.role
        }
        // this.userrole = res.data.role;
        // this.usersex = res.data.sex;
        // this.isuse = res.data.isuse;
        this.editparms = res.data
      }
    })
    this.formObj.dialogVisible = true
  }

  private handleClose(done: any) {
    this.formObj.dialogVisible = false
    this.addParams = {
      username: '',
      loginname: '',
      phone: '',
      password: '',
      copesd: '',
      orgnanizeid: ''
    }
  }

  private async subMitData() {
    const form = this.$refs.addParams as any
    form.validate(async(valid: boolean) => {
      if (valid) {
        if (this.editparms.id) {
          let addparam = {
            id: this.editparms.id,
            isdelete: 0,
            isuse: this.addParams.isuse,
            loginName: this.addParams.loginname,
            organname: this.addParams.orgnanizeid,
            phone: this.addParams.phone,
            pwd: this.addParams.password,
            role: this.addParams.role,
            sex: this.addParams.sex,
            userName: this.addParams.username
          }
          await updatauser(addparam).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false
              form.resetFields()
              this.$message.success('修改成功')
              this.getList(this.listQuery)
            }
          })
        } else {
          let params = {
            isuse: 0,
            loginName: this.addParams.loginname,
            organName: this.addParams.orgnanizeid,
            phone: this.addParams.phone,
            pwd: this.addParams.password,
            role: this.addParams.role,
            sex: this.addParams.sex,
            userName: this.addParams.username
          }

          await adddata(params).then((res) => {
            if (res.code === 200) {
              this.formObj.dialogVisible = false
              form.resetFields()
              this.$message.success('添加成功')
              this.getList(this.listQuery)
            } else if (res.code == 201) {
              this.$message.warning('密码不能小于6位')
            } else if (res.code == 108) {
              this.$message.warning(
                '登录名或者联系方式已存在，请修改后重新提交'
              )
            }
          })
        }
      } else {
        return false
      }
    })
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val
    this.getList(this.listQuery)
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.getList(this.listQuery)
  }
  private cellStyle({
                      row,
                      column,
                      rowIndex,
                      columnIndex
                    }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return 'text-align:center'
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return 'text-align:center'
  }
}
